import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import { updateAchievement } from '@/plugins/firebase-monitoring';

import * as types from './mutations-types';

export function setCatCard({ commit }, catCard) {
  commit(types.SET_CAT_CARD, catCard);

  return Promise.resolve(catCard);
}

export function fetchCatCard({ dispatch }, { catId, params }) {
  return http.get(`${MINERVA_API_URL}/cats/${catId}`, { params })
    .then(resp => (
      dispatch('setCatCard', resp.data)
    ));
}

export function updateCoreConceptsAchievement({ getters }, { cat, coreConceptIds, quizResults }) {
  const userId = getters.currentUserId;
  return updateAchievement(userId, cat, coreConceptIds, quizResults);
}

export function fetchCatRanking({ commit }, { params }) {
  return http.get(`${MINERVA_API_URL}/cat_ranking`, { params })
    .then(res => commit(types.SET_CAT_RANKING, res.data))
    .catch(err => Promise.reject(err.respoonse));
}
